<div mat-button [matMenuTriggerFor]="menu" class="mb-3 cursor-pointer" i18n-title title="Zobraziť ďalšie možnosti">
    <a><b>{{slavnost.nazov}}</b> -  {{slavnost.typSlavnosti}}</a>
    {{slavnost.datum|date}} {{slavnost.cas}}
    <div *ngIf="slavnost.datumOd"><span class="fw-bold" i18n>Dátum</span>: {{getDatum(slavnost)}}</div>
    <div *ngIf="slavnost.prihlasovanieOd">
      <span class="fw-bold" i18n>Prihlasovanie</span>: {{slavnost.prihlasovanieOd | date}} - {{slavnost.prihlasovanieDo | date}}
    </div>
    <div *ngIf="slavnost.potvrdzovanieOd">
      <span class="fw-bold" i18n>Potvrdzovanie</span>: {{slavnost.potvrdzovanieOd | date}} - {{slavnost.potvrdzovanieDo | date}}
    </div>
    <div *ngIf="slavnost.obmedzenie">
      <span class="fw-bold" i18n>Maximálny počet</span>: {{slavnost.obmedzenie}}
    </div>
    <div class="mt-2" *ngIf="slavnost.zucastnimSa != null">
      <div class="d-inline" *ngIf="slavnost.zucastnimSa; else elseBlock">
          <ul><li><span i18n>Účasť potvrdená</span></li></ul>
      </div>
      <ng-template #elseBlock><ul><li><span i18n>Účasť odmietnutá</span></li></ul></ng-template>
    </div>

<mat-menu #menu="matMenu">

  <button mat-menu-item class="small" (click)="odhlasitZoSlavnosti()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Odhlásiť zo slávnosti</span>
  </button>

  <button mat-menu-item class="small" (click)="potvrditUcast()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Potvrdenie účasti</span>
  </button>

  <button mat-menu-item class="small" (click)="odmietnutUcast()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Odmietnutie účasti</span>
  </button>

</mat-menu>
</div>
